import { createSelector } from '@reduxjs/toolkit';

import { selectSpecialtyTypes } from 'shared/selectors/jsonQuery';

import { selectSpecialtyTypesOptions } from './selectSpecialtyTypesOptions';

const DEFAULT_LABEL = 'Назначение';

export const selectSpecialtyTypesLabel = createSelector(
  [selectSpecialtyTypes, selectSpecialtyTypesOptions],
  (values, options) => {
    if (!values || values.length === 0) {
      return DEFAULT_LABEL;
    }

    const labels = values.map(value => options.find(opt => opt.value === value)?.label).filter(Boolean);

    if (labels.length === 0) {
      return `${DEFAULT_LABEL}: ${values.length}`;
    }

    return labels.join(', ');
  },
);
